import axios from 'axios'

const API_URL = `${process.env.REACT_APP_API_URL}`

const Users = {
  getAllUsers() {
    return axios({
      method: 'get',
      url: `${API_URL}/users`,
    })
  },

  createUser(user) {
    return axios({
      method: 'post',
      url: `${API_URL}/add_user`,
      data: user,
    })
  },

  deleteUser(id) {
    return axios({
      method: 'delete',
      url: `${API_URL}/user/${id}`,
    })
  },

  updateUser(updUser) {
    const { user_id, ...data } = updUser
    return axios({
      method: 'put',
      url: `${API_URL}/edit_user/${user_id}`,
      data,
    })
  },

  getUserPreferences() {
    return axios({
      method: 'get',
      url: `${API_URL}/preferences`,
    })
  },

  updateUserPreferences(updUser) {
    return axios({
      method: 'put',
      url: `${API_URL}/change_preferences`,
      data: updUser,
    })
  },

  changeUserPassword(newPassword) {
    return axios({
      method: 'put',
      url: `${API_URL}/change_password`,
      data: newPassword,
    })
  },

  checkUserSetups(setupId) {
    return axios({
      method: 'get',
      url: `${API_URL}/check_setup_users`,
      params: {
        setup_id: setupId,
      },
    })
  },

  userLogRequest(userId) {
    return axios({
      method: 'post',
      url: `${API_URL}/user_request_logs`,
      data: userId,
    })
  },
}

export default Users
